import { useTranslation } from 'react-i18next';
import { AILoadingAnimation } from '~/modules/valuation/pages/AddValuation/AILoadingAnimation';

const PropertyDataAnalysisStep = () => {
  const { t } = useTranslation('app');

  return (
    <div className="px-2x md:px-0 pt-4x md:pt-6x flex flex-col gap-5x justify-center items-center">
      <AILoadingAnimation />
      <p className="text-title_4 text-gray__dark_2">{t('finalAnalyzing')}</p>
    </div>
  );
};

export default PropertyDataAnalysisStep;
